<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import url('./assets/sass/flex.css');
@import url('./assets/sass/common.scss');
@import url('../static/fa/css/font-awesome.css');
@import url('//at.alicdn.com/t/c/font_1665910_82wzvyygwcg.css');
.condition .el-input__inner{
    height: 30px!important;
    padding: 0 10px;
    line-height: 30px!important;
    // background: rgba(#0247EB, 0.05)!important;
}
.condition .el-input__icon{
    line-height: 30px;
}
.select-course .el-table__header th{
    background: #F7F7F7;
}
img{
    max-width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue